import { combineReducers } from 'redux';
import sessionReducer from './session.js';
import notificationsReducer from './notifications.js';
import uiReducer from './ui.js';

const rootReducer = combineReducers({
  sessionState: sessionReducer,
  notifications: notificationsReducer,
  ui: uiReducer(),
});

export default rootReducer;
